function enhanceSpecialSiteButtons() {
  document
    .querySelectorAll('.service-special-site .wp-block-button__link')
    .forEach(function (btn) {
      var screenReaderEl = btn.querySelector(
        '.u-visually-hidden, .screen-reader-text'
      );

      var clone = btn.cloneNode(true);
      clone
        .querySelectorAll('.u-visually-hidden, .screen-reader-text')
        .forEach(function (el) {
          el.remove();
        });
      var text = clone.textContent.trim();

      var textWrap = document.createElement('span');
      textWrap.className = 'c-primary-btn__text';

      var orig = document.createElement('span');
      orig.className = 'text-original';
      orig.textContent = text;

      var hov = document.createElement('span');
      hov.className = 'text-hover';
      hov.textContent = text;

      textWrap.appendChild(orig);
      textWrap.appendChild(hov);

      var iconWrap = document.createElement('span');
      iconWrap.className = 'c-primary-btn__icon';
      iconWrap.setAttribute('aria-hidden', 'true');
      iconWrap.innerHTML =
        '<svg class="icon-original" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg"><path d="M11.0847 8.5H3V7.5H11.0847L7.28717 3.7025L8 3L13 8L8 13L7.28717 12.2975L11.0847 8.5Z"/></svg>' +
        '<svg class="icon-hover"    viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg"><path d="M11.0847 8.5H3V7.5H11.0847L7.28717 3.7025L8 3L13 8L8 13L7.28717 12.2975L11.0847 8.5Z"/></svg>';

      btn.textContent = '';
      btn.appendChild(textWrap);
      btn.appendChild(iconWrap);
      if (screenReaderEl) {
        screenReaderEl.style.cssText =
          'position:absolute;width:1px;height:1px;overflow:hidden;clip:rect(0,0,0,0);white-space:nowrap;';
        btn.appendChild(screenReaderEl);
      }

      btn.classList.add('c-primary-btn', 'c-primary-btn--black');
    });
}

export default function serviceDetailAnim() {
  enhanceSpecialSiteButtons();
  var reduceMotion = window.matchMedia(
    '(prefers-reduced-motion: reduce)'
  ).matches;

  function animateLabelTo(d, newText) {
    var btn = d.querySelector('summary .c-button__view');
    var t = d.querySelector('summary .c-button__text');
    if (!t || t.textContent === newText) return;
    var w0 = btn ? btn.offsetWidth : null;
    t.textContent = newText;
    if (!btn || w0 === null || reduceMotion) return;
    btn.style.transition = 'none';
    btn.style.width = 'auto';
    var w1 = btn.offsetWidth;
    if (w0 === w1) {
      btn.style.width = '';
      btn.style.transition = '';
      return;
    }
    btn.style.whiteSpace = 'nowrap';
    btn.style.width = w0 + 'px';
    btn.offsetHeight;
    btn.style.transition = 'width 0.4s cubic-bezier(0.16, 1, 0.3, 1)';
    btn.style.width = w1 + 'px';
    function onEnd(e) {
      if (e.propertyName !== 'width') return;
      btn.removeEventListener('transitionend', onEnd);
      btn.style.width = '';
      btn.style.transition = '';
      btn.style.whiteSpace = '';
    }
    btn.addEventListener('transitionend', onEnd);
  }

  function setLabel(d) {
    animateLabelTo(
      d,
      d.open
        ? d.getAttribute('data-label-open') || ''
        : d.getAttribute('data-label-closed') || ''
    );
  }

  var spQuery = window.matchMedia('(max-width: 1024px)');

  function animateOpen(d) {
    d.open = true;
    animateLabelTo(d, d.getAttribute('data-label-open') || '');
    if (reduceMotion) return;
    var desc = d.querySelector('.issue-card__desc');
    if (!desc) return;

    if (spQuery.matches) {
      desc.style.height = 'auto';
      desc.style.opacity = '0';
      requestAnimationFrame(function () {
        desc.style.opacity = '1';
      });
      return;
    }

    var h = desc.scrollHeight;
    desc.style.height = '0';
    desc.style.opacity = '0';
    requestAnimationFrame(function () {
      desc.style.height = h + 'px';
      desc.style.opacity = '1';
      function onEnd(e) {
        if (e.propertyName !== 'height') return;
        desc.removeEventListener('transitionend', onEnd);
        desc.style.height = 'auto';
        desc.style.opacity = '';
      }
      desc.addEventListener('transitionend', onEnd);
    });
  }

  function animateClose(d) {
    animateLabelTo(d, d.getAttribute('data-label-closed') || '');
    if (reduceMotion) {
      d.open = false;
      return;
    }
    var desc = d.querySelector('.issue-card__desc');
    if (!desc) {
      d.open = false;
      return;
    }

    if (spQuery.matches) {
      desc.style.opacity = '0';
      var cleaned = false;
      var cleanup = function () {
        if (cleaned) return;
        cleaned = true;
        desc.removeEventListener('transitionend', onFade);
        desc.style.height = '';
        desc.style.opacity = '';
        d.open = false;
      };
      var onFade = function (e) {
        if (e.propertyName !== 'opacity') return;
        cleanup();
      };
      desc.addEventListener('transitionend', onFade);
      setTimeout(cleanup, 400);
      return;
    }

    desc.style.height = desc.scrollHeight + 'px';
    desc.style.opacity = '1';
    desc.offsetHeight;
    desc.style.height = '0';
    desc.style.opacity = '0';
    function onEnd(e) {
      if (e.propertyName !== 'height') return;
      desc.removeEventListener('transitionend', onEnd);
      desc.style.height = '';
      desc.style.opacity = '';
      d.open = false;
    }
    desc.addEventListener('transitionend', onEnd);
  }

  document
    .querySelectorAll('details.issue-card__content')
    .forEach(function (d) {
      setLabel(d);
      var s = d.querySelector('summary.issue-card__btn');
      if (s)
        s.addEventListener('click', function (e) {
          e.preventDefault();
          if (d.open) {
            animateClose(d);
          } else {
            animateOpen(d);
          }
        });
    });
}
